import { createFeatureSelector, createSelector } from "@ngrx/store";
import { WarningState } from "../reducers/warning.reducer";



export const selectWarningState = createFeatureSelector<WarningState>('warning');



// export const selectShowWarning = createSelector(selectWarningState,(state: WarningState) => state.show);
export const selectWarningSummary = createSelector(selectWarningState,(state: WarningState) => state.summary);
export const selectWarningDetail = createSelector(selectWarningState,(state: WarningState) => state.detail);
export const selectWarningBlockedDocument = createSelector(selectWarningState,(state: WarningState) => state.blockedDocument);